import { useState, useCallback } from "react";

const useFetch = (url, options) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // Determine if we have a valid URL to fetch from.
  const isUrlValid = Boolean(url);

  const fetchData = useCallback(
    async (requestBody) => {
      if (!isUrlValid) return;

      setIsLoading(true);
      try {
        const response = await fetch(url, {
          ...options,
          method: options.method || "GET",
          body:
            options.method && options.method.toUpperCase() !== "GET"
              ? requestBody instanceof FormData
                ? requestBody
                : JSON.stringify(requestBody)
              : undefined,
          headers: {
            ...(requestBody instanceof FormData
              ? {}
              : { "Content-Type": "application/json" }),
            ...(options.headers || {}),
          },
        });

        const result = await response.json();
        if (!response.ok) {
          setError(result);
        }

        setData(result);
        setError(null);
      } catch (error) {
        setError(error.message || "Something went wrong");
      } finally {
        setIsLoading(false);
      }
    },
    [url, options]
  );

  return { data, error, isLoading, fetchData };
};

export default useFetch;
